import { tracker } from "@openreplay/tracker";
import ENV from "../../env";
// Define type for window.env
interface EnvConfig {
  TRACKER_ENABLED: string;
  TRACKER_PROJECT_KEY: string;
  TRACKER_REV_ID: string;
  PRODUCTION: boolean;
  NODE_ENV: string;
  ORIGIN: string;
  ASSETS_HOST: string;
  API_EDP: string;
  VERSION: string;
  TRACKER_VERSION: string;
  TRACKER_HOST: string;
  SOURCEMAP: boolean;
  CRISP_KEY: string;
  CAPTCHA_ENABLED: string;
  CAPTCHA_SITE_KEY: string;
}

declare global {
  interface Window {
    env: EnvConfig;
  }
}

// Utility to check if a URL matches sensitive endpoints
const isSensitiveUrl = (url: string): boolean => {
  const sensitivePatterns = [
    "/login",
    "/signup",
    "/credentials",
    "/events",
    "/account/password",
    "/account",
    ".mob",
    "/integrations/",
  ];
  return sensitivePatterns.some(
    (pattern) => url.includes(pattern) || url.endsWith(pattern),
  );
};

tracker.configure({
  projectKey: ENV.TRACKER_PROJECT_KEY,
  // env.ts does not map TRACKER_REV_ID; vite defines every .env key on process.env
  revID: process.env.TRACKER_REV_ID,
  longTasks: true,
  captureIFrames: false,
  __debug__: 3,
  disableStringDict: true,
  __DISABLE_SECURE_MODE: true, //!window.env.PRODUCTION,
  analytics: {
    active: true,
  },
  network: {
    capturePayload: true,
    sanitizer: (data) => {
      const { url } = data;
      if (isSensitiveUrl(url)) {
        // Mask request body for sensitive endpoints
        data.request.body = "";

        // Mask response body for successful requests to sensitive endpoints
        if (data.status < 400) {
          data.response.body = "";
        }
      }

      return data;
    },
  },
});

export const trackerInstance = tracker;
